import { render } from "./edititemsmovement.vue?vue&type=template&id=0e05c6e0&scoped=true"
import script from "./edititemsmovement.vue?vue&type=script&lang=js"
export * from "./edititemsmovement.vue?vue&type=script&lang=js"

import "./edititemsmovement.vue?vue&type=style&index=0&id=0e05c6e0&scoped=true&lang=css"

import exportComponent from "/Users/zonegoh/Documents/GitHub/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e05c6e0"]])

export default __exports__